// TODO: switch to tracking from fluxer
export const API_URL = "api.lanyard.rest";

export const HEARTBEAT_INTERVAL = 30_000;

export const USER_ID = "1121961711080050780";

export const DATE_OF_BIRTH = {
  date: 25,
  month: 8,
  year: 2005,
};

export const USER = "yofukashino_";

export default { API_URL, HEARTBEAT_INTERVAL, USER_ID, DATE_OF_BIRTH, USER };
